import * as React from 'react';
import type {Except} from 'type-fest';

import {useStack} from '../hooks';
import {VStackView} from '../Stack.styles';

import type {StackProps} from '../_types';

/**
 * # VStack
 *
 * VStack creates a vertical flowing `Stack` with spacing.
 *
 * ## Usage
 *
 * ```jsx
 * import { VStack } from "@packages/systems/spring";
 * import {SomeComponent} from '../SomeComponent';
 *
 * const Example = () => {
 *   return (
 *     <VStack>
 *       <SomeComponent>First</SomeComponent>
 *       <SomeComponent>Second</SomeComponent>
 *       <SomeComponent>Third</SomeComponent>
 *     </VStack>
 *   );
 * };
 * ```
 *
 * @component
 */
export const VStack = React.forwardRef<
  HTMLDivElement,
  Except<StackProps, 'direction'>
>(({align = 'stretch', ...props}, ref) => {
  const stackProps = useStack(props);

  return (
    <VStackView {...stackProps} align={align} direction="column" ref={ref} />
  );
});

VStack.displayName = 'VStack';
VStack.toString = VStackView.toString;
